module.exports = __webpack_public_path__ + "banquet/containers/MarketingPricingContainer/images/coming_back.3b55c1d34c80919e84c81ee57f218283.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/containers/MarketingPricingContainer/images/coming_back.png
// module id = 1714
// module chunks = 1